module.exports = __webpack_public_path__ + "media/images/gallery/7-3aa5fd9c01fa309f7afc492abcfa903d.jpg";